import styled from 'styled-components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const InputWrapper = styled.div`
  width: 100%;
`

interface IInputContainerProps {
  error?: boolean
}

export const InputContainer = styled.div<IInputContainerProps>`
  display: flex;
  width: 100%;
  height: 40px;
  padding: 6px 8px;
  border: 1px solid ${({ theme, error }) => (error ? theme.border.error : theme.border.default)};
  border-radius: 8px;
  background: #f9fafb;

  font-family: 'Inter', sans-serif;
  transition: 0.3s;

  &:hover {
    border: 1px solid ${({ theme, error }) => (error ? theme.border.error : theme.border.hover)};
  }
  &:focus-within {
    border: 1px solid ${({ theme, error }) => (error ? theme.border.error : theme.border.focus)};
  }
  &.error {
    border: 1px solid ${({ theme }) => theme.border.error};
  }
  &:focus-visible {
    outline: none;
  }
  &:hover:has(input:disabled),
  &:focus-within:has(input:disabled) {
    border-color: ${baseTheme.colors.lightGrey};
  }
`

export const Input = styled.input`
  width: 100%;
  color: ${({ theme }) => theme.text.primary};

  font-size: ${baseTheme.typography.fontSize.md};
  font-family: 'Inter', sans-serif;
  font-weight: 400;

  &:focus {
    border: none;

    ${InputContainer} {
      border: 1px solid ${({ theme, error }) => (error ? theme.border.error : 'red')};
    }
  }

  &:focus-visible {
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.text.placeholder};
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    font-family: 'Inter', sans-serif;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: ${({ theme }) => theme.text.primary};
    box-shadow: 0 0 0px 1000px transparent inset;
  }

  &[type='number'] {
    -moz-appearance: textfield; // for Firefox

    &::-webkit-inner-spin-button,  // for Chrome, Safari, new Opera
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &:disabled {
    color: #9a9b9c;
  }
`

export const StartAdornmentContainer = styled.div`
  margin-right: 8px;
`

export const EndAdornmentContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 8px;
`
